

  <section style="overflow-y: scroll;height: 100%;">
    <div class="wrapper">
    <label class="diagnostic-label"  style="width: 90%;">Key Pathology/Biology features</label>
    <button type="button" class="add-boutton fa fa-search-plus" style="left: 70%;width: 6%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25%;  font-weight: normal;" name="Addfont" (click)="ZoomIn()"></button>
    <button type="button" class="add-boutton fa fa fa-search-minus" style="left: 76%;width: 6%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25% ;font-weight: normal;" name="Munesfont" (click)="ZoomOut()"></button>
    <button type="button" class="add-boutton" [disabled]="disablepharnacy" style="left: 83%" name="Add" (click)="openDialog()">Add</button>
    </div>


<BR>
<BR>
   <table style="left: 5%;width: 90%;">
    <tr *ngFor="let item of DiganosiseList; let i = index" style="font-size: {{wk_fontsize}};text-align: left;">
      <td>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div>
            <label style="font-weight: bold;">{{item.digdate}} {{item.username}} </label>
          </div>
          <div>
            <button class="fa fa-pencil" [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: green;" matTooltip="Edit" name="Add" (click)="EditDiganosis(item)"></button>
            <button class="fa fa-trash" [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: red;" matTooltip="Delete" name="Delete" (click)="MessegeDelete(item)"></button>
          </div>
        </div>
        <label >{{item.cancerid}}</label>
        <BR>
          <BR>
            <label >♦{{item.tissue}}</label> - <label [hidden] = "wk_Heddin_histology[i]">{{item.histology}}</label>

            <BR>
              <label [hidden] = "wk_Heddin_er[i]">♦{{item.er}}</label>-<label [hidden] = "wk_Heddin_pr[i]">{{item.pr}}</label> - <label [hidden] = "wk_Heddin_her2ihs[i]">{{item.her2ihs}}</label>        - <label [hidden] = "wk_Heddin_her2fish[i]">{{item.her2fish}}</label> - <label [hidden] = "wk_Heddin_ki67[i]">{{item.ki67text}}%</label>
              <BR>

              <label [hidden] = "wk_Heddin_pdl1[i]">♦{{item.pdl1}}</label> - <label [hidden] = "wk_Heddin_brca1[i]">{{item.brca1}} - {{item.brca2}}</label>
        <BR>
        <label [hidden] = "wk_Heddin_digstage[i]">♦{{item.digstage}}</label> - <label [hidden] = "wk_Heddin_grade[i]">{{item.grade}}</label>
        <BR>
        <label [hidden] = "wk_Heddin_digt[i]">♦{{item.digt}}</label> - <label [hidden] = "wk_Heddin_dign[i]">{{item.dign}}</label> - <label [hidden] = "wk_Heddin_digm[i]">{{item.digm}}</label>
        <label [hidden] = "wk_Heddin_her2[i]">{{item.her2}}</label>
         <BR [hidden] = "wk_Heddin_her2[i]">
        <label [hidden] = "wk_Heddin_msi[i]">{{item.msi}}</label>
        <BR [hidden] = "wk_Heddin_msi[i]">
        <label [hidden] = "wk_Heddin_egfr[i]">{{item.egfr}}</label>
        <BR [hidden] = "wk_Heddin_egfr[i]">
        <label [hidden] = "wk_Heddin_alk[i]">{{item.alk}}</label>
        <BR [hidden] = "wk_Heddin_alk[i]">

        <label [hidden] = "wk_Heddin_kras[i]">{{item.kras}}</label>
        <BR [hidden] = "wk_Heddin_kras[i]">
        <label [hidden] = "wk_Heddin_braf[i]">{{item.braf}}</label>
        <BR [hidden] = "wk_Heddin_braf[i]">
        <label [hidden] = "wk_Heddin_hrd[i]">{{item.hrd}}</label>
        <BR [hidden] = "wk_Heddin_hrd[i]">
        <label [hidden] = "wk_Heddin_gscore[i]">{{item.gscore}}</label>
        <BR [hidden] = "wk_Heddin_gscore[i]">
        <label [hidden] = "wk_Heddin_nfeature[i]">{{item.nfeature}}</label>
        <BR [hidden] = "wk_Heddin_nfeature[i]">

        <BR [hidden] = "wk_Heddin_her2fish[i]">
        <label [hidden] = "wk_Heddin_hpv[i]">{{item.hpv}}%</label>
        <label [hidden] = "wk_Heddin_hpv[i]">{{item.digmain}}</label>
        <BR>
        <label >Others :  {{item.digmain}}</label>

        <br>
        <br>
      </td>
    </tr>
  </table>
  </section>

